<template>
    <div id="container" type="vmortgagerates">
        <div class="page page-mortgagerates" v-ga:request="{pageType:'vmortgagerates', state: {}}" v-ga:page="{pageType:'vmortgagerates', glb: glb, state: {}}">
            <mvtHeader />
            <section class="inline large">
                <div class="grid xs-grid-cols-1 fixed fixed-max-sm gap-3">
                    <div class="text-center">
                        <h1><b class="f0 text-bold">Compare Today’s Mortgage Rates</b></h1>
                    </div>
                    <compareRates />
                </div>
            </section>

            <section class="inline large">
                <mvtLazyload>
                    <mvtRateTrend></mvtRateTrend>
                </mvtLazyload>
            </section>

            <mortgageTools :id="glb.pageType" preTitle="EXPERT GUIDANCE AND RESOURCES" title="Tools for every step of your real estate journey"></mortgageTools>

            <section class="inline large">
                <div class="grid xs-grid-cols-1 fixed fixed-max-sm gap-3">
                    <div class="text-center">
                        <h2>
                            <b class="f3 text-bold">Frequently Asked Questions</b>
                        </h2>
                    </div>
                    <mvtFaq v-if="faqQuery" :query="faqQuery"></mvtFaq>
                </div>
            </section>

            <section class="inline large" v-if="tag">
                <div class="grid xs-grid-cols-1 fixed fixed-max-sm gap-3">
                    <div class="text-center">
                        <h2><b class="f3 text-bold">Related Articles</b></h2>
                    </div>
                    <mvtArticle :tag="tag" />
                </div>
            </section>
            <mvtFooter />
        </div>
        <mvtDialogCenter></mvtDialogCenter>
    </div>
</template>

<script src="./page-mortgagerates.js"></script>
